import { createAction, props } from '@ngrx/store';
import { type } from '@app/util/util';
import { HttpErrorResponse } from '@angular/common/http';

import { PackageSeachPayload, PackageSeachResponse } from '@packages/packages-result/entities/packages-search';
import {
  AirGroupedResultPackagesResponse, AirResultPackagesPayload, AirResultPackagesResponse
} from '@packages/packages-result/entities/air-results';
import { HotelResultPackagesPayload, HotelResultPackagesResponse } from '@packages/packages-result/entities/hotel-results';
import { AirResultOptionResponse } from '@packages/packages-result/entities/air-results';
import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';
import { FetchFlightsOptionPayload } from '@flight-results/entities/fetch-flights-option.payload';
import { FlightResultDesktop } from '@app/entities/flight-results';
import { PackageHotelFilterPayload } from '@packages/packages-result/entities/package-hotel-filter';
import { HotelAmenity } from '@hotels/hotel-results/entities/hotel-filters.response';
import { PackageAirFilterPayload } from '@packages/packages-result/entities/package-air-filter';
import { ZoneResponse } from '@app/entities/zones.response';
import { AirFiltersResponse, HotelFiltersResponse } from '@shared/magic-filter-bar/entities/filter-types';
import { HotelSearchLocationByPackages } from '@hotels/hotel-results/entities/hotel-search-location';

export const searchPackageAction = createAction(
  type('[PackagesResult/API] Search packages'),
  props<{ payload: PackageSeachPayload }>()
);
export const searchPackageRequestAction = createAction(
  type('[PackagesResult/API] Search packages request'),
  props<{ payload: PackageSeachPayload }>()
);
export const searchPackageFlightsForMobileAction = createAction(
  type('[PackagesResult/API] Search package flights form mobile'),
  props<{ payload: AirResultPackagesPayload, fetchFilters: boolean, block?: boolean }>()
);
export const searchPackageFlightsForMobileSuccessAction = createAction(
  type('[PackagesResult/API] Search package flights form mobile success'),
  props<{ response: AirResultPackagesResponse }>()
);
export const searchPackageFlightsForMobileWithPaginationAction = createAction(
  type('[PackagesResult/API] Search package flights form mobile with pagination'),
  props<{ payload: AirResultPackagesPayload }>()
);
export const searchPackageFlightsForMobileWithPaginationSuccessAction = createAction(
  type('[PackagesResult/API] Search package flights form mobile with pagination success'),
  props<{ response: AirResultPackagesResponse }>()
);
export const searchPackageFlightsForDesktopAction = createAction(
  type('[PackagesResult/API] Search package flights form desktop'),
  props<{ payload: AirResultPackagesPayload, fetchFilters: boolean, block?: boolean }>()
);
export const searchPackageFlightsForDesktopSuccessAction = createAction(
  type('[PackagesResult/API] Search package flights form desktop success'),
  props<{ response: AirGroupedResultPackagesResponse }>()
);
export const searchPackageFlightsForDesktopWithPaginationAction = createAction(
  type('[PackagesResult/API] Search package flights form desktop with pagination'),
  props<{ payload: AirResultPackagesPayload }>()
);
export const searchPackageDesktopForMobileWithPaginationSuccessAction = createAction(
  type('[PackagesResult/API] Search package flights form desktop with pagination success'),
  props<{ response: AirGroupedResultPackagesResponse }>()
);
export const searchPackageHotelsAction = createAction(
  type('[PackagesResult/API] Search package hotels'),
  props<{ payload: HotelResultPackagesPayload, searchPayload: PackageSeachPayload }>()
);
export const searchPackageHotelsWithPaginationAction = createAction(
  type('[PackagesResult/API] Search package hotels with pagination'),
  props<{ payload: HotelResultPackagesPayload }>());
export const searchPackageHotelsWithMarkersAction = createAction(
  type('[PackagesResult/API] Search package hotels with markers'),
  props<{ payload: HotelResultPackagesPayload, block?: boolean }>());
export const searchPackageHotelsWithMarkersSuccessAction = createAction(
  type('[PackagesResult/API] Search package hotels with markers success'),
  props<{ response: HotelResultPackagesResponse }>());
export const searchPackageHotelsWithPaginationSuccessAction = createAction(
  type('[PackagesResult/API] Search package hotels with pagination success'),
  props<{ response: HotelResultPackagesResponse }>()
);
export const searchPackageHotelsSuccessAction = createAction(
  type('[PackagesResult/API] Search package hotels success'),
  props<{ response: HotelResultPackagesResponse }>()
);
export const fetchPackageHotelsFilterAction = createAction(
  type('[PackagesResult/API] Fetch package hotels filters'),
  props<{ payload: PackageHotelFilterPayload, response: HotelResultPackagesResponse }>()
);
export const fetchPackageHotelsFilterSuccessAction = createAction(
  type('[PackagesResult/API] Fetch package hotels filters success'),
  props<{ response: HotelFiltersResponse, ammenities: HotelAmenity[] }>()
);
export const searchPackageHotelsWithFiltersAction = createAction(
  type('[PackagesResult/API] Search package hotels with filters'),
  props<{ payload: HotelResultPackagesPayload, block?: boolean }>()
);
export const searchPackageHotelsWithFiltersSuccessAction = createAction(
  type('[PackagesResult/API] Search package hotels with filters success'),
  props<{ response: HotelResultPackagesResponse }>()
);
export const fetchPackageAirFilterAction = createAction(
  type('[PackagesResult/API] Fetch package air filters'),
  props<{
    payload: PackageAirFilterPayload,
    response: AirResultPackagesResponse | AirGroupedResultPackagesResponse,
    isMobile: boolean
  }>()
);
export const fetchPackageAirFilterSuccessAction = createAction(
  type('[PackagesResult/API] Fetch package air filters success'),
  props<{ response: AirFiltersResponse }>()
);
export const fetchPackageHotelTopZonesSuccessAction = createAction(
  type('[PackagesResult/API] Fetch hotel top zones Success'),
  props<{ zones: ZoneResponse[] }>()
);

export const fetchFlightsOptionForPackageAction = createAction(
  type('[PackagesResult/Data] Fetch flight option packages'),
  props<{ payload: FetchFlightsOptionPayload }>()
);
export const fetchFlightsOptionForPackageErrorAction = createAction(
  type('[PackagesResult/Data] Fetch flight option packages error')
);
export const fetchFlightsOptionForPackageSuccessAction = createAction(
  type('[PackagesResult/Data] Fetch flight option packages success')
);
export const searchPackageFlightsForMobileErrorAction = createAction(
  type('[PackagesResult/Data] PackagesResult Flights For Mobile error'),
  props<{ payload: HttpErrorResponse }>()
);
export const searchPackageFlightsForDesktopErrorAction = createAction(
  type('[PackagesResult/Data] PackagesResult Flights For Desktop error'),
  props<{ payload: HttpErrorResponse }>()
);
export const searchPackageHotelsErrorAction = createAction(
  type('[PackagesResult/Data] PackagesResult Hotel For Desktop error'),
  props<{ payload: HttpErrorResponse }>()
);
export const savePackageSearchDataAction = createAction(
  type('[PackagesResult/Data] PackagesResult Save Package Search Data'),
  props<{ response: PackageSeachResponse }>()
);
export const setAirSelectedAction = createAction(
  type('[PackagesResult/Data] Set air selected by params'),
  props<{ payload: AirResultOptionResponse }>()
);
export const setHotelSelectedAction = createAction(
  type('[PackagesResult/Data] Set hotel selected by params'),
  props<{ payload: HotelSearched }>()
);
export const setAirSelectedDesktopAction = createAction(
  type('[PackagesResult/Data] Set air selected by params DESKTOP'),
  props<{ payload: FlightResultDesktop }>()
);
export const clearPackageResultsAction = createAction(
  type('[PackagesResult/Data] Clear packages results')
);

export const resetPackageSelectedOptionsAction = createAction(
  type('[PackagesResult/UI] Reset packages data selection')
);
export const setHotelRoomSelectedAction = createAction(
  type('[PackagesResult/UI] Set packages hotel rate id selection'),
  props<{ id: string }>());
export const disabledInfinityScrollAction = createAction(
  type('[PackagesResult/UI] Disabled package result infinity scroll'));
export const setShowedPackageDetailsAction = createAction(
  type('[PackagesResult/UI] Set showd package details in flights'),
  props<{ payload: string }>()
);
export const setPackageBaseUrlResultAction = createAction(
  type('[PackagesResult/UI] Set packages url base for flights'),
  props<{ url: string }>()
);
export const fetchPackageHotelDetailSearchedAction = createAction(
  type('[Hotels/DATA] Fetch package hotel detail searched'),
  props<{ hotel: HotelSearched }>()
);
export const searchLocationOrHotelInfoByCodeAction = createAction(
  type('[PackagesResult/DATA] Search location or hotel info by code'),
  props<{ payload: HotelSearchLocationByPackages }>()
);

export const setHotelMapView = createAction(
  type('[PackagesResult/DATA] Set Hotel Map View'),
  props<{ payload: boolean }>()
);
